module.exports = __webpack_public_path__ + "img/Logo_Branco_Estado_MT.6234630d.png";